import axios from 'axios';

export const UserService = {
  async changePassword(payload) {
    const res = await axios.put('api/resetPassword/', payload);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async getUsers(page, perPage = 10) {
    const res = await axios.get('/rbac/v1/paydausers/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async getAllUsers() {
    const res = await axios.get('/rbac/v1/paydausers/all/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createUser(payload) {
    const res = await axios.post('/rbac/v1/users/', payload);

    if (res.status === 201) {
      return res.data.id;
    }

    return Promise.reject();
  },
  async updateUser(userId, payload) {
    const res = await axios.put(`/rbac/v1/users/${userId}/`, payload);

    if (res.status === 200) {
      return res.data.id;
    }

    return Promise.reject();
  },
  async attachRoleToUser(payload) {
    const res = await axios.put('/rbac/v1/users/attach/role/', payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },
};
